import { useCallback } from "react";
import { useAppSelector } from "../redux/hooks";
import ar from "./locales/ar.json";
import en from "./locales/en.json";

type TranslationKeys = keyof typeof ar;

const translations: Record<string, Record<string, string>> = { ar, en };

export function useTranslation() {
  const language = useAppSelector((s) => s.company.language);

  const t = useCallback(
    (key: TranslationKeys | string, params?: Record<string, string>) => {
      let value = translations[language]?.[key] ?? key;
      if (params) {
        Object.entries(params).forEach(([k, v]) => {
          value = value.replace(`{{${k}}}`, v);
        });
      }
      return value;
    },
    [language],
  );

  const dir = language === "ar" ? "rtl" : "ltr";
  const isRTL = language === "ar";

  return { t, dir, isRTL, language } as const;
}
